import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import CursorProvider from './context/CursorContext.js';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <CursorProvider>
        <App />
    </CursorProvider>
);
